import { MutationTree } from 'vuex';
import { TransportsState } from './types';

export const mutations: MutationTree<TransportsState> = {
    setTransports:(state, data) => {
        state.transports = data.transports
    },
    setTransportProtocols:(state, data) => {
        state.transportProtocols = data.protocols
    },
    setProtocolParameters:(state, data) => {
        state.protocolParameters = data.parameters
    },
    setTransportsMultichannel:(state, data) => {
        state.transportsMultichannel = data.transports
    }
};